import { Box, styled } from '@mui/material';

export const StyledScrollableContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'maxHeight' && prop !== 'hasNoScrollBar' && prop !== 'smoothScroll',
})<{ maxHeight?: string; hasNoScrollBar?: boolean; smoothScroll?: boolean }>(({
  maxHeight,
  hasNoScrollBar,
  smoothScroll,
}) => {
  return {
    position: 'relative',
    maxHeight: maxHeight || 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '8px 1rem 1rem',
    width: '100%',
    height: hasNoScrollBar ? 'auto' : '100%',
    scrollbarWidth: 'none',
    scrollBehavior: smoothScroll ? 'smooth' : 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
  };
});
